<template>
  <div class="success-box flex flex-direction f-center f-around">
    <div>
      <el-image
        class="record-img pa-l-20"
        :src="require('../img/success.jpg')"
        fit="cover"
      >
      </el-image>
      <div class="ma-t-40 fon-24 c-000 font-bold t-center">
      
        <span >支付成功</span>
      </div>
    </div>
    <div class="flex f-around">
      <router-link to="/">
        <el-button type="primary" class="btn home-btn">去首页</el-button>
      </router-link>
      <router-link :to="{path:'/user/index',query:{id:1}}">
        <el-button type="success" class="btn detail-btn">去我的课程</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
// let _this
export default {
  components: {

  },
  data () {
    return {
      type: ''
    }
  },
  created () {
    // _this = this
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.success-box {
  margin-top: 30px;
//   margin-bottom: 30px;
  height: 640px;
  background: #ffffff;
  .btn {
    width: 216px;
    height: 51px;
    border-radius: 10px;
    color: #ffffff;
    font-size: 16px;
    &.home-btn {
      margin-right: 160px;
    }
  }
}
</style>
